import { api } from "./client";
import type { components } from "./contract";
import { unwrap } from "./errors";

export type V2GenerationAuthority =
  components["schemas"]["V2GenerationAuthority"];

export async function getGenerationAuthority(
  generationID: string,
): Promise<V2GenerationAuthority> {
  return unwrap(
    await api.GET("/v1/generations/{id}/authority", {
      params: { path: { id: generationID } },
    }),
  );
}
